export const exampleJS = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const exampleJS = document.querySelector('.exampleJS');

        if (exampleJS) {
            console.log('exampleJS');
        }
    });
};
